// File: assets/info-chart-lightbox.js

(function () {
  'use strict';

  function initInfoChartLightboxes() {
    var triggers = document.querySelectorAll('.info-chart-trigger');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      var lightboxId = trigger.getAttribute('data-lightbox');
      var lightbox = lightboxId
        ? document.getElementById(lightboxId)
        : trigger.closest('.accordion__content').querySelector('.info-chart-lightbox');

      if (!lightbox) return;

      if (lightbox.parentElement !== document.body) {
        document.body.appendChild(lightbox);
      }

      trigger.addEventListener('click', function () {
        openLightbox(lightbox);
      });
    });
  }

  function openLightbox(lightbox) {
    lightbox.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    var img = lightbox.querySelector('.info-chart-lightbox__img');
    var stage = lightbox.querySelector('.info-chart-lightbox__stage');
    var closeBtn = lightbox.querySelector('.info-chart-lightbox__close');

    // ===== Nút X cố định ở góc phải-trên viewport =====
    if (closeBtn) {
      closeBtn.style.position = 'fixed';
      closeBtn.style.top = '1.5rem';
      closeBtn.style.right = '1.5rem';
      closeBtn.style.zIndex = '10001';
    }

    // Config — KHÔNG cho phép thu nhỏ hơn fit-to-screen
    var minScale = 1;
    var maxScale = 6;
    var doubleTapScale = 2.5;

    // State
    var scale = 1;
    var translateX = 0;
    var translateY = 0;

    // ===== Setup stage & image =====
    stage.style.overflow = 'hidden';
    stage.style.position = 'relative';
    stage.style.display = 'block';
    stage.style.touchAction = 'none';
    stage.style.userSelect = 'none';
    stage.style.webkitUserSelect = 'none';

    img.style.position = 'absolute';
    img.style.left = '0';
    img.style.top = '0';
    img.style.maxWidth = 'none';
    img.style.maxHeight = 'none';
    img.style.transformOrigin = '0 0';
    img.style.transition = 'none';
    img.style.willChange = 'transform';
    img.style.touchAction = 'none';
    img.style.userSelect = 'none';
    img.style.webkitUserDrag = 'none';
    img.draggable = false;

    // QUAN TRỌNG: phải set kích thước stage thủ công vì khi ảnh
    // position: absolute thì stage không còn cách nào tự co dãn theo ảnh.
    function sizeStage() {
      var vw = window.innerWidth;
      var vh = window.innerHeight;
      var w = Math.min(vw * 0.92, 860);
      var h = vh * 0.9;
      stage.style.width = w + 'px';
      stage.style.height = h + 'px';
    }
    sizeStage();

    function fitImage() {
      var sRect = stage.getBoundingClientRect();
      var natW = img.naturalWidth || 1;
      var natH = img.naturalHeight || 1;
      var ratio = Math.min(sRect.width / natW, sRect.height / natH, 1);
      var fitW = natW * ratio;
      var fitH = natH * ratio;
      img.style.width = fitW + 'px';
      img.style.height = fitH + 'px';
      scale = 1;
      translateX = (sRect.width - fitW) / 2;
      translateY = (sRect.height - fitH) / 2;
      if (translateY < 0) translateY = 0;
      applyTransform();
    }

    function clampTranslation() {
      var sRect = stage.getBoundingClientRect();
      var w = img.offsetWidth * scale;
      var h = img.offsetHeight * scale;

      if (w <= sRect.width) {
        translateX = (sRect.width - w) / 2;
      } else {
        if (translateX > 0) translateX = 0;
        if (translateX < sRect.width - w) translateX = sRect.width - w;
      }
      if (h <= sRect.height) {
        translateY = (sRect.height - h) / 2;
      } else {
        if (translateY > 0) translateY = 0;
        if (translateY < sRect.height - h) translateY = sRect.height - h;
      }
    }

    function applyTransform() {
      clampTranslation();
      img.style.transform =
        'translate3d(' + translateX + 'px,' + translateY + 'px,0) scale(' + scale + ')';
      img.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    }

    function zoomAt(newScale, pointX, pointY) {
      newScale = Math.max(minScale, Math.min(maxScale, newScale));
      if (newScale === scale) return;
      var imgX = (pointX - translateX) / scale;
      var imgY = (pointY - translateY) / scale;
      scale = newScale;
      translateX = pointX - imgX * scale;
      translateY = pointY - imgY * scale;
      applyTransform();
    }

    function getStagePoint(clientX, clientY) {
      var rect = stage.getBoundingClientRect();
      return { x: clientX - rect.left, y: clientY - rect.top };
    }

    // Init
    if (img.complete && img.naturalWidth) {
      fitImage();
    } else {
      img.addEventListener('load', fitImage, { once: true });
    }

    function onResize() {
      sizeStage();
      fitImage();
    }
    window.addEventListener('resize', onResize);

    // ===== CLOSE =====
    var justPanned = false;

    function close() {
      lightbox.setAttribute('hidden', '');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      lightbox.removeEventListener('click', onLightboxClick);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    }

    function onLightboxClick(e) {
      if (justPanned) { justPanned = false; return; }
      if (e.target.closest('.info-chart-lightbox__close')) { close(); return; }
      if (e.target.closest('.info-chart-lightbox__img')) return;
      close();
    }
    lightbox.addEventListener('click', onLightboxClick);

    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);

    // ===== MOUSE PAN =====
    var isMousePanning = false;
    var mStartX = 0, mStartY = 0, mStartTX = 0, mStartTY = 0;
    var mDidDrag = false;

    img.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      if (scale <= 1) return;
      e.preventDefault();
      isMousePanning = true;
      mDidDrag = false;
      mStartX = e.clientX;
      mStartY = e.clientY;
      mStartTX = translateX;
      mStartTY = translateY;
      img.style.cursor = 'grabbing';
    });

    function onMouseMove(e) {
      if (!isMousePanning) return;
      var dx = e.clientX - mStartX;
      var dy = e.clientY - mStartY;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) mDidDrag = true;
      translateX = mStartTX + dx;
      translateY = mStartTY + dy;
      applyTransform();
    }
    function onMouseUp() {
      if (isMousePanning) {
        isMousePanning = false;
        if (mDidDrag) justPanned = true;
        img.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
      }
    }
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);

    // ===== DOUBLE-CLICK =====
    img.addEventListener('dblclick', function (e) {
      e.preventDefault();
      var p = getStagePoint(e.clientX, e.clientY);
      if (scale > 1) {
        fitImage();
      } else {
        zoomAt(doubleTapScale, p.x, p.y);
      }
    });

    // ===== WHEEL ZOOM =====
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var p = getStagePoint(e.clientX, e.clientY);
      var factor = e.deltaY > 0 ? 0.95 : 1.05;
      zoomAt(scale * factor, p.x, p.y);
    }, { passive: false });

    // ===== TOUCH =====
    var isPinching = false;
    var pinchStartDist = 0;
    var pinchStartScale = 1;
    var pinchStartMid = { x: 0, y: 0 };
    var pinchStartTX = 0;
    var pinchStartTY = 0;

    var isTouchPanning = false;
    var tStartX = 0, tStartY = 0, tStartTX = 0, tStartTY = 0;
    var touchMoved = false;

    var lastTapTime = 0;
    var lastTapPos = { x: 0, y: 0 };

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        isPinching = true;
        isTouchPanning = false;
        var t1 = e.touches[0], t2 = e.touches[1];
        pinchStartDist = getPinchDist(t1, t2);
        pinchStartScale = scale;
        pinchStartTX = translateX;
        pinchStartTY = translateY;
        var midClient = getPinchMid(t1, t2);
        pinchStartMid = getStagePoint(midClient.x, midClient.y);
      } else if (e.touches.length === 1 && !isPinching) {
        var t = e.touches[0];
        tStartX = t.clientX;
        tStartY = t.clientY;
        tStartTX = translateX;
        tStartTY = translateY;
        touchMoved = false;
        isTouchPanning = true;
      }
    }, { passive: false });

    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && isPinching) {
        e.preventDefault();
        var t1 = e.touches[0], t2 = e.touches[1];
        var dist = getPinchDist(t1, t2);
        var midClient = getPinchMid(t1, t2);
        var sp = getStagePoint(midClient.x, midClient.y);

        var newScale = Math.max(
          minScale,
          Math.min(maxScale, pinchStartScale * (dist / pinchStartDist))
        );
        var imgX = (pinchStartMid.x - pinchStartTX) / pinchStartScale;
        var imgY = (pinchStartMid.y - pinchStartTY) / pinchStartScale;
        scale = newScale;
        translateX = sp.x - imgX * scale;
        translateY = sp.y - imgY * scale;
        applyTransform();
      } else if (e.touches.length === 1 && isTouchPanning && !isPinching) {
        var t = e.touches[0];
        var dx = t.clientX - tStartX;
        var dy = t.clientY - tStartY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) touchMoved = true;
        if (scale > 1 && touchMoved) {
          e.preventDefault();
          translateX = tStartTX + dx;
          translateY = tStartTY + dy;
          applyTransform();
        }
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (e.touches.length === 0) {
        if (!touchMoved && !isPinching && e.changedTouches.length === 1) {
          var t = e.changedTouches[0];
          var p = getStagePoint(t.clientX, t.clientY);
          var now = Date.now();
          var ddx = p.x - lastTapPos.x;
          var ddy = p.y - lastTapPos.y;
          var nearLast = Math.sqrt(ddx * ddx + ddy * ddy) < 30;
          if (now - lastTapTime < 320 && nearLast) {
            if (scale > 1) {
              fitImage();
            } else {
              zoomAt(doubleTapScale, p.x, p.y);
            }
            lastTapTime = 0;
          } else {
            lastTapTime = now;
            lastTapPos = p;
          }
        }
        isPinching = false;
        isTouchPanning = false;
      } else if (e.touches.length === 1 && isPinching) {
        isPinching = false;
        var t = e.touches[0];
        tStartX = t.clientX;
        tStartY = t.clientY;
        tStartTX = translateX;
        tStartTY = translateY;
        touchMoved = true;
        isTouchPanning = true;
      }
    }, { passive: false });

    stage.addEventListener('touchcancel', function () {
      isPinching = false;
      isTouchPanning = false;
    }, { passive: true });
  }

  function getPinchDist(t1, t2) {
    var dx = t1.clientX - t2.clientX;
    var dy = t1.clientY - t2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function getPinchMid(t1, t2) {
    return {
      x: (t1.clientX + t2.clientX) / 2,
      y: (t1.clientY + t2.clientY) / 2
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfoChartLightboxes);
  } else {
    initInfoChartLightboxes();
  }

})();